

import Cookies from 'universal-cookie';



const cookies = new Cookies();




export const isAuthenticatedBoss = () => {


	// console.log("Cookies BOSS_TOKEN", cookies.get('BOSS_TOKEN'));
	console.log("cookies.get('BOSS_AUTHENTICATED')", cookies.get('BOSS_AUTHENTICATED'));


	return cookies.get('BOSS_AUTHENTICATED');


}

export const getAccessTokenBoss = () => {
	console.log("BOSS_TOKEN:", cookies.get("BOSS_TOKEN"));
	return cookies.get("BOSS_TOKEN");
}


export const depositLastPathBoss = (currentPath) => {
	cookies.set("lastBossPath", currentPath, { path: '/' });
	console.log("lastBossPath:", cookies.get("lastPath"));
}

export const getLastPathBoss = () => {
	console.log("lastPath:", cookies.get("lastBossPath"));
	return cookies.get("lastBossPath");
}

// export const getNavigateUri = () => {
// 	console.log("redirect_boss_uri:", cookies.get("redirect_boss_uri"));
// 	return cookies.get("redirect_boss_uri");
// }


export const removeAuthenticationBoss = () => {

	console.log("autheticated cookies", cookies.get("AUTHETICATED"));
	console.log("BOSS_TOKEN cookies", cookies.get("BOSS_TOKEN"));
	cookies.remove("BOSS_AUTHENTICATED", { path: '/' });
	cookies.remove("BOSS_TOKEN", { path: '/' });
	cookies.remove("BOSS_INFO", { path: '/' });
	console.log("autheticated cookies", cookies.get("AUTHETICATED"));
	console.log("BOSS_TOKEN cookies", cookies.get("BOSS_TOKEN"));
}

export const saveAuthenticationBoss = (token) => {
	// const cookies = new Cookies();
	console.log("token:", token);
	cookies.set('BOSS_TOKEN', token, { path: '/' });
	// cookies.set('BOSS_AUTHENTICATED', true, { path: '/' });
	// console.log("BOSS_TOKEN", cookies.get('BOSS_TOKEN'));


}

export const saveUserInfoBoss = (bossinfo) => {
	// const cookies = new Cookies();
	console.log("save bossinfo:", bossinfo);
	cookies.set('BOSS_INFO', bossinfo, { path: '/' });
	cookies.set('BOSS_AUTHENTICATED', true, { path: '/' });
	// console.log("BOSS_TOKEN", cookies.get('BOSS_TOKEN'));


}

export const userInfoBoss = () => {
	console.log("bossinfo:", cookies.get("BOSS_INFO"));
	return cookies.get("BOSS_INFO");


}






// ### below



export const restaurantListSize = 3;


export const isAuthenticated = () => {

	let result = cookies.get('AUTHENTICATED');

	console.log("cookiesutil result", result);
	if (typeof result === 'undefined')
		result = false;

	return result;


}

export const getAccessToken = () => {
	console.log("ACCESS_TOKEN:", cookies.get("ACCESS_TOKEN"));
	return cookies.get("ACCESS_TOKEN");
}


export const depositLastPath = (currentPath) => {
	cookies.set("lastCustomerPath", currentPath, { path: '/' });
	console.log("lastCustomerPath:", cookies.get("lastCustomerPath"));
}

export const getLastPath = () => {
	console.log("lastCustomerPath:", cookies.get("lastCustomerPath"));
	return cookies.get("lastCustomerPath");
}




export const removeAuthentication = () => {

	console.log("autheticated cookies", cookies.get("AUTHETICATED"));
	console.log("ACCESS_TOKEN cookies", cookies.get("ACCESS_TOKEN"));
	cookies.remove("AUTHENTICATED", { path: '/' });
	cookies.remove("ACCESS_TOKEN", { path: '/' });
	cookies.remove("USER_INFO", { path: '/' });
	console.log("autheticated cookies removed", cookies.get("AUTHETICATED"));
	console.log("ACCESS_TOKEN cookies removed", cookies.get("ACCESS_TOKEN"));
	console.log("ACCESS_TOKEN cookies removed", cookies.get("USER_INFO"));
}

export const saveAuthentication = (token) => {
	// const cookies = new Cookies();
	console.log("token:", token);
	cookies.set('ACCESS_TOKEN', token, { path: '/' });
	// cookies.set('AUTHENTICATED', true, { path: '/' });
	// console.log("ACCESS_TOKEN", cookies.get('ACCESS_TOKEN'));


}

export const saveUserInfo = (userInfo) => {
	// const cookies = new Cookies();
	console.log("save userInfo:", userInfo);
	// remove the overside part of userInfo,and use token to amend them.

	let uf = {
		em: userInfo.email,
		emv: userInfo.evd, id: userInfo.id,
		im: userInfo.imageUrl,
		nm: userInfo.name, pd: userInfo.provider,
		pid: userInfo.providerId, ro: userInfo.roles,
		cdc: userInfo.cdc,
		ph: userInfo.phone, pmv: userInfo.pvd,
	}

	cookies.set('UF', uf, { path: '/' });
	cookies.set('AUTHENTICATED', true, { path: '/' });

}

export const userInfo = () => {
	console.log("get userInfo:", cookies.get("UF"));

	let result = cookies.get("UF");
	let finalResult;

	if (typeof result === 'undefined')
		// return false;
	return {email:'none', name:'none'}

	finalResult = {
		email: result.em, emailVerified: result.emv, id: result.id,
		imageUrl: result.im, name: result.nm, provider: result.pd,
		providerId: result.pid, roles: result.ro, cdc: result.cdc,
		phone: result.ph, phoneVerified: result.pmv,
	}


	return finalResult;


}

export const depositRecentBrowsedRestaurantList = (recentRestaurant) => {

	let RecentBrowsedRestaurantList = getRecentBrowsedRestaurantList();


	if (RecentBrowsedRestaurantList === 0)
		RecentBrowsedRestaurantList = [];



	RecentBrowsedRestaurantList = RecentBrowsedRestaurantList.reverse();

	let index = RecentBrowsedRestaurantList.map(x => x.id).indexOf(recentRestaurant.id);
	if (index === -1) {
		RecentBrowsedRestaurantList.push(recentRestaurant);
	} else {
		RecentBrowsedRestaurantList.splice(index, 1);
		RecentBrowsedRestaurantList.push(recentRestaurant);
	}


	if (RecentBrowsedRestaurantList.length > restaurantListSize)
		RecentBrowsedRestaurantList.splice(0, 1);

	RecentBrowsedRestaurantList = RecentBrowsedRestaurantList.reverse();


	// size reducing by remove names,and convert it to array
	let final = RecentBrowsedRestaurantList.filter(el => typeof el !== 'undefined').map(
		el => {
			let newEl = [];
			console.log("newEl e", el);
			newEl.push(el.id);
			newEl.push(el.name);

			console.log("newEl", newEl);

			// if (el.id !== null)
			return newEl;

		}
	)



	cookies.set("RVR", final, { path: '/' });
	console.log("RecentBrowsedRestaurantList:", cookies.get("RVR"));
}

export const getRecentBrowsedRestaurantList = () => {
	console.log("RecentBrowsedRestaurantList:", cookies.get("RVR"));

	let result = cookies.get("RVR");
	if (typeof result === 'undefined')
		return 0;


	result = result.map(
		el => {

			let newEl = {};

			newEl.id = el[0];
			newEl.name = el[1];

			return newEl;

		}
	)



	return result;
}


